/**
 * #669 — scribe comments are always single-line, no newlines, ever. Real
 * scribes never enter multi-line comments; a stray line break (paste of
 * multi-line clipboard text, IME/drag-drop, or a value stored before this
 * rule existed) must never survive into the stored or displayed value.
 *
 * Enter itself never reaches the input — useSheetFieldNav's handleKeyNav
 * (#668) preventDefaults every Enter keypress and moves focus instead — so
 * this function only ever has real work to do for paste/IME/programmatic
 * writes and legacy data. It's a no-op (returns the input unchanged) for
 * ordinary typing, so it never fights the scribe mid-sentence (e.g. trimming
 * a trailing space they just typed).
 *
 * @param {string|null|undefined} value
 * @returns {string} the value with every newline variant (\r\n, \r, \n)
 *   collapsed to a single space, runs of resulting whitespace collapsed, and
 *   the ends trimmed. Values with no newline pass through untouched.
 */
export function normalizeRemarks(value) {
  const v = value ?? "";
  if (!/[\r\n]/.test(v)) return v;
  return v.replace(/[\r\n]+/g, " ").replace(/ {2,}/g, " ").trim();
}
